import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Checkbox, Spin } from "antd";
import { ClockIcon, InfoIconOutlined } from "../../../../atoms/CustomIcons";
import TextArea from "antd/es/input/TextArea";
import IconFieldWorkflow from "../../../../atoms/CustomIcons/IconFieldWorkflow";
import IconDollarCircle from "../../../../atoms/CustomIcons/IconDollarCircle";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  btnApi: () => void;
  loading: boolean;
}

const TerminatePopUp = (props: PropsType) => {
  const { onClose, btnApi, loading } = props;

  const onCloseHandler = () => {
    onClose();
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div
        className="modalWrapper terminate_contract_popup"
        style={{ gap: "0px" }}
      >
        <div
          className="modal_header"
          style={{ marginBottom: "32px", textAlign: "center" }}
        >
          <div className="title">
            <h2 style={{ marginBottom: "12px" }}> Terminate contract </h2>
            <p style={{ color: "#000000", marginBottom: "10px" }}>
              You can terminate the contract if it’s not completed but has to be
              closed.
            </p>
            <p style={{ color: "#E04949" }}>
              This contract has unfinished work orders and unpaid work.
            </p>
          </div>
        </div>

        <div className="modal_content">
          <div className="tiles_parent first_row">
            <div className="modal_tiles">
              <div className="title">
                <IconDollarCircle /> Gross margin
              </div>
              <div className="numeric_val"> 54 % </div>
            </div>
            <div className="modal_tiles">
              <div className="title">
                <IconFieldWorkflow /> Production efficiency
              </div>
              <div className="numeric_val"> 105 % </div>
            </div>
            <div className="modal_tiles">
              <div className="title">
                <ClockIcon /> Overtime
              </div>
              <div className="numeric_val"> 0 % </div>
            </div>
          </div>
          <div className="tiles_parent second_row">
            <div className="modal_tiles">
              <div className="title">
                <IconDollarCircle /> Work orders completed
              </div>
              <div className="numeric_val"> 2 / 8 </div>
            </div>
            <div className="modal_tiles">
              <span className="infoTooltipIcon">
                <InfoIconOutlined />
              </span>

              <div className="title">
                <IconDollarCircle /> Outstanding balance due
              </div>
              <div className="numeric_val"> $ 12,450.07 </div>
            </div>
          </div>
          <div className="checkbox_area">
            <Checkbox />
            <div className="its_text">
              <span style={{ color: "#000" }}>
                Issue final invoice for the outstanding balance.
              </span>
              <span style={{ color: "#626A6E" }}>
                You can adjust the amount in the invoice before sending.
              </span>
            </div>
          </div>
          <TextArea
            placeholder="Write note here ..."
            onChange={(e) => e.stopPropagation()}
            style={{ marginBottom: "24px" }}
          />
        </div>

        <div className="modal_footer" style={{ margin: "0 auto" }}>
          <Button
            htmlType="button"
            className="outlined-btn"
            type="default"
            size="large"
            onClick={onCloseHandler}
          >
            Cancel
          </Button>

          <Button
            htmlType="button"
            className="mint-btn"
            type="primary"
            size="large"
            onClick={btnApi}
            loading={loading}
          >
            Terminate contract
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default TerminatePopUp;
